import React, {useContext, FunctionComponent} from 'react';
import './AddToHomeScreenAndroid.less';

import {TranslationsContext} from '../../../contexts/translations-context';

import {getSafeTranslation} from '../../../helpers/localization.helper';
import {AndroidButton} from '../../elements/android-button/AndroidButton';

//@ts-ignore
import DownloadIcon from '../../../images/download.svg';

interface AddToHomeScreenAndroidProps {
	onDoneClick: () => void
}

export const AddToHomeScreenAndroid: FunctionComponent<AddToHomeScreenAndroidProps> = ({onDoneClick}) => {
	const translations = useContext(TranslationsContext);

	return (<div className="add-to-home-screen-android">
		<div className="add-to-home-screen-android__text-container">
			<div className="add-to-home-screen-android__description">
				{
					getSafeTranslation('AddToHomeScreenPopup.description', translations)
				}
			</div>
			<div className="add-to-home-screen-android__install">
				<AndroidButton
					icon={DownloadIcon}
					text={getSafeTranslation('AddToHomeScreenPopup.installButtonCaption', translations)}
					onClick={onDoneClick}
				/>
			</div>
		</div>
	</div>);
};
